import { Divider, FlexBox } from '@vp/swan'
import TopMobileMenu from './TopMobileMenu'
import { NavMobileMenu } from '../../navigation/mobile'
import type { OpenPanelParams } from '../../../../hooks/useMobileMenuNavigation'
import type { BrandItem, HeaderLink } from '../../../../types/site-header'
import type { NavigationCategory } from '../../../../types/navigation'
import BottomMobileMenu from './BottomMobileMenu'

type PrimaryPanelProps = Readonly<{
  helpLink: HeaderLink
  myProjectsLink: HeaderLink
  navigationData: NavigationCategory[]
  openPanel: (params: OpenPanelParams) => void
  brands: BrandItem[]
  brandsDesktop: BrandItem[]
  brandsHeading: string
  isRedesignedSignInButtonEnabled: boolean
}>

export default function PrimaryPanel({
  helpLink,
  myProjectsLink,
  navigationData,
  openPanel,
  brands,
  brandsDesktop,
  brandsHeading,
  isRedesignedSignInButtonEnabled,
}: PrimaryPanelProps) {
  const openAccountPanel = (title: string) => openPanel({ panel: 'account', title })
  const openNavPanel = (title: string, id: string) => openPanel({ panel: 'navCategory', title, id })

  return (
    <FlexBox flexDirection="column" style={{ width: '100%' }}>
      <TopMobileMenu
        helpLink={helpLink}
        myProjectsLink={myProjectsLink}
        openAccountPanel={openAccountPanel}
        isRedesignedSignInButtonEnabled={isRedesignedSignInButtonEnabled}
      />
      <Divider my={3} />
      <NavMobileMenu navigationData={navigationData} openNavPanel={openNavPanel} />
      <BottomMobileMenu brands={brands} brandsDesktop={brandsDesktop} brandsHeading={brandsHeading} />
    </FlexBox>
  )
}
